function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.66 17.296h3.064v-6.128h6.129V8.104h-6.129V1.976H7.66v6.128H1.532v3.064H7.66v6.128z",
  fill: "#231F20"
});

var SvgPlusIcninline = function SvgPlusIcninline(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 19",
    fill: "none"
  }, props), _ref);
};

export default SvgPlusIcninline;